import { useMutation, useQueryClient } from 'react-query'

import { AppEvents, QUERY_KEYS } from 'src/constants'
import { rewardPointsService } from 'src/services/reward-points.service'

export const useRemoverewardPoints = () => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => rewardPointsService.removeRewardPoints(ids), {
    onSuccess: async (data) => {
      if (data) {
        const detail = { message: data.message }

        const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
        document.dispatchEvent(event)

        queryClient.invalidateQueries(QUERY_KEYS.REWARD_POINTS)
      }
    },
  })
}
